import { buildApiClient } from "@core/api-client/RetryableBearerApiClient";
import type TipType from "@core/enums/TipType";

export async function getTipsAsync(): Promise<TipType[]> {
    return await buildApiClient(window.env.ACTIVITIES_API_URL).getAsync("/api/v1/tips");
}

export async function dismissTipAsync(tip: TipType): Promise<void> {
    return await buildApiClient(window.env.ACTIVITIES_API_URL).postAsync(`/api/v1/tips/${tip}/dismiss`);
}